<template>
  <div class="edit_test_wrapper w3-responsive">
    <h3>{{testDef.test_pack_name}}</h3>
    <table class="w3-table w3-table-all">
      <tr>
        <th>test name <input class="w3-input" type="text" placeholder="filter" v-model="filter.testNames"></th>
        <th>code</th>
        <th>result</th>
        <th>unit</th>
        <th>norm</th>
      </tr>
      <tr v-for="(test,index) in testDef.params" v-bind:class="{'w3-hide':checkFit(test.test_name, test.test_code)}" v-bind:key="'res_row'+index">
        <td>{{test.test_name}}</td>
        <td>{{test.test_code}}</td>
        <td>
          <input class="" v-model="values[test.test_type_id]">
          <div v-if="test.value_helper">
            <button class="w3-button" v-for="(option, pos) in test.value_helper.split('|')" :key="pos"  @click="toggleOptionInValueHelper(option, test.test_type_id)"> {{option}} </button>
            
            <button class="w3-button" @click="clearOptionInValueHelper(test.test_type_id)">clear</button>
          </div>
        </td>
        <td>{{test.test_unit}}</td>
        <td>{{test.test_norm}}</td>
      </tr>
    </table>
    <button class="w3-button" @click="submitData()">submit</button>
  </div>
</template>

<script>
export default {
  data: function() {
    // console.log(this.prefillData.length);
    console.log(this.prefillData);

    let dat = {}
    this.testDef.params.forEach(param => {
      console.log("createing param: ")
      console.log(param)
      dat[param.test_type_id] = ""
    });

    if((Object.keys(this.prefillData.prefillData).length > 0)){
      let prefillData = this.prefillData.prefillData
      Object.keys(this.prefillData.prefillData).forEach( function(key){
        // console.log(prefillData)
        // console.log(prefillData[key])
        dat[key] = prefillData[key]
      } )
    }

    return {
      filter:{
        testNames: ""
      },
      values: dat
    };
    // }
  },
  props: ["prefillData", "testDef"],
  methods: {
    checkFit: function(test_name, test_code){
      // console.log(test_name, test_code)
      // console.log("names is:")
      // console.log(this.filter.testNames)
      // console.log("tokens is:")
      // console.log(this.filter.testNames.toLowerCase().split(" "))
      return this.filter.testNames.toLowerCase().split(" ").find(testNameToken=>{
          if(testNameToken == '') false
          if(testNameToken == ',') false
          
          if(test_name && test_name.toLowerCase().includes(testNameToken)) return true
          if(test_code && test_code.toLowerCase().includes(testNameToken)) return true
        }
      ) == undefined
    },
    submitData: function() {
      console.log(this.values);
      
      this.$emit("test-submited", { values:this.values, testDef:this.testDef});
    },
    toggleOptionInValueHelper: function(option, test_type_id){
      console.log("adding value to input field " + option + " " + test_type_id)
      console.log(this.values)
      this.values[test_type_id] += option + ' '
    },
    clearOptionInValueHelper: function(test_type_id){
      console.log("clearing values")
      this.values[test_type_id] = ''
    }
  }
};
</script>